import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import Endpoints from '../endpoints';
import { SettingsDTO } from '../types/settings';

@Injectable()
export class SettingsService {
  constructor(private http: HttpClient) { }

  public getSettings(params: HttpParams): Observable<SettingsDTO[]> {
    return this.http.get<SettingsDTO[]>(Endpoints.GET_SETTINGS, { params: params });
  }

  public saveSettings(siteId: string, data: SettingsDTO): Observable<any> {
    return this.http.patch<any>(Endpoints.SAVE_SETTINGS(siteId), data);
  }
}
